export default "__VITE_ASSET__B6sKFdJ3__"